import { ICloneable } from '../interfaces/cloneable.interface';
import { ObjectUtils } from '../utils/object.utils';

export interface EventAttachmentModelLike {
  id?: string;
  text?: string;
  url?: string;
}

export interface EventObjectModelLike {
  id?: string;
  type?: string;
  entityId?: string;
  objectRegisterId?: string;
}

export interface EventModelLike {
  id?: string;
  subject?: string;
  description?: string;
  geometry?: string;
  attachments?: EventAttachmentModelLike[];
  objects?: EventObjectModelLike[];
}

export class EventModel implements EventModelLike, ICloneable<EventModel> {
  id?: string;
  subject?: string;
  description?: string;
  geometry?: string;
  attachments?: EventAttachmentModelLike[];
  objects?: EventObjectModelLike[];

  constructor(item?: Partial<EventModelLike>) {
    this.id = item?.id;
    this.subject = item?.subject;
    this.description = item?.description;
    this.geometry = item?.geometry;
    this.attachments =
      item?.attachments?.map((x) => ObjectUtils.clone(x)) ?? [];
    this.objects = item?.objects?.map((x) => ObjectUtils.clone(x)) ?? [];
  }

  clone() {
    return new EventModel(this);
  }
}
